import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Components from "./components/Components";
import Contact from "./components/Contact";
import "./App.css";
import Services from "./components/Services";
import FeaturesPage from "./components/Features";
import ProjectsPage from "./components/Project";
import Footer from "./Footer";
import ScrollToTop from "./components/scrollToTop";

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/components" element={<Components />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about/features" element={<FeaturesPage />} />
          <Route path="/about/services" element={<Services />} />
          <Route path="/about/projects" element={<ProjectsPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
